import { render } from "./baseProductOverviewItemCard.vue?vue&type=template&id=e3a728ca&ts=true"
import script from "./baseProductOverviewItemCard.vue?vue&type=script&lang=ts"
export * from "./baseProductOverviewItemCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__